module.exports = "../../static/img/default-profile.a28de9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-profile.jpg
// module id = 498
// module chunks = 1